/* eslint-disable no-undef */

import Utils from "@/Utils";

let dialogCloseFunctions = []

// this gets called by the android webview client, do NOT remove it.
window.closeTopDialog = () => {
  console.log(`closeTopDialog ${dialogCloseFunctions.length}`)
  if(dialogCloseFunctions && dialogCloseFunctions.length > 0) {
    let func = dialogCloseFunctions[dialogCloseFunctions.length - 1] //don't pop--it'll get popped when setFullscreen(false) is called upond dialog closing.
    func()
  }
}

class AndroidInterface {

  shouldFetchLocalizedPricing() {
    return this.installedFromGooglePlay() && typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.getLocalizedPrice !== 'undefined';
  }

  async fetchLocalizedPricing(subscriptionId) {

    console.log(`fetching pricing for ${subscriptionId}`)

    let localizedPrice = null
    let attempt = 0
    while (!localizedPrice && attempt < 100) {
      localizedPrice = JavascriptToAndroidInterface.getLocalizedPrice(subscriptionId)
      console.log(`fetching pricing for ${subscriptionId} returned ${localizedPrice}`)
      if (!localizedPrice) {
        await Utils.sleep(250)
      }
      attempt++
    }

    return localizedPrice
  }

  installedFromGooglePlay() {
    if(typeof JavascriptToAndroidInterface !== 'undefined') {

      if(typeof JavascriptToAndroidInterface.getInstalledAppPackageName !== 'undefined') {
        //returns com.android.vending if installed from Google Play Store
        const installingPackage = JavascriptToAndroidInterface.getInstalledAppPackageName()
        console.log(`installingPackage = ${installingPackage}`)
        return installingPackage === 'com.android.vending' || installingPackage === 'com.google.android.feedback' || installingPackage === null || installingPackage === undefined
      } else {
        return true //if they're on an older version of the app that doesn't have that function then they installed from Google Play
      }
    } else {
      return null
    }
  }

  getInstalledPackageName() {
    if(typeof JavascriptToAndroidInterface !== 'undefined') {

      if(typeof JavascriptToAndroidInterface.getInstalledAppPackageName !== 'undefined') {
        const installingPackage = JavascriptToAndroidInterface.getInstalledAppPackageName()
        return installingPackage
      } else {
        return 'getInstalledAppPackageName is undefined' //if they're on an older version of the app that doesn't have that function then they installed from Google Play
      }
    } else {
      return 'JavascriptToAndroidInterface is undefined'
    }
  }

  getApplicationId() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.getApplicationId !== 'undefined') {
      return JavascriptToAndroidInterface.getApplicationId()
    }
    return null
  }

  getCredentials() {
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      return JavascriptToAndroidInterface.getCredentials()
    } else {
      return null
    }
  }

  /**
   * Communicates to the android app that a dialog or something else is opened that should allow the app to use the full screen
   * and hide the toolbar.
   * @param val
   */
  /**
   * Intercepts the Android back button without entering fullscreen.
   * When back is pressed, closeFunc is called instead of closing the activity.
   */
  setBackIntercept(val, closeFunc) {
    console.log(`setBackIntercept ${val}`)
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      if(val) {
        dialogCloseFunctions.push(closeFunc)
      } else {
        dialogCloseFunctions.pop()
      }

      if(typeof JavascriptToAndroidInterface.setBackIntercept !== 'undefined') {
        JavascriptToAndroidInterface.setBackIntercept(val)
      }
    }
  }

  setFullscreen(val, closeFunc) {
    console.log(`setFullscreen ${val}`)
    if(typeof JavascriptToAndroidInterface !== 'undefined') {

      if(val) {
        dialogCloseFunctions.push(closeFunc)
      } else {
        dialogCloseFunctions.pop()
      }

      JavascriptToAndroidInterface.setFullscreen(val)
    }
  }

  getAppVersion() {
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      return JavascriptToAndroidInterface.getAppVersion()
    }
    return undefined
  }

  openWebsiteInBrowser(url) {
    console.log(`openWebsiteInBrowser ${url}`)
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      JavascriptToAndroidInterface.openWebsiteInBrowser(url)
    }
  }

  openAppPageInBrowser(page) {
    console.log(`openAppPageInBrowser ${page}`)
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      JavascriptToAndroidInterface.openAppPageInBrowser(page)
    }
  }

  openAbout() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.openAbout !== 'undefined') {
      JavascriptToAndroidInterface.openAbout()
    }
  }

  openBatteryOptimization() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.openBatteryOptimization !== 'undefined') {
      JavascriptToAndroidInterface.openBatteryOptimization()
    }
  }

  checkForFailedGooglePlayPurchases() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.checkForFailedGooglePlayPurchases !== 'undefined') {
      JavascriptToAndroidInterface.checkForFailedGooglePlayPurchases()
    }
  }

  canUseGooglePlayForPurchases() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscriptionV2 !== 'undefined') {
      console.log('canUseGooglePlayForPurchases true')
      return true
    }
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscription !== 'undefined') {
      console.log('canUseGooglePlayForPurchases true')
      return true
    }
    console.log('canUseGooglePlayForPurchases false')
    return false
  }

  purchaseThroughGooglePlay(subscriptionId, plan, price) {
    //v2
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscriptionV2 !== 'undefined') {
      JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscriptionV2(subscriptionId, plan, price)
      return
    }

    //v1
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscription !== 'undefined') {
      JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscription(subscriptionId)
      return
    }
  }

  changeThroughGooglePlay(subscriptionId, purchaseToken) {
    console.log(`calling ${JavascriptToAndroidInterface.changeGooglePlayInAppSubscription}`)
    JavascriptToAndroidInterface.changeGooglePlayInAppSubscription(purchaseToken, subscriptionId)
  }
}

export default (new AndroidInterface())
